import { render, staticRenderFns } from "./energy-rating.vue?vue&type=template&id=cb75448a&"
import script from "./energy-rating.vue?vue&type=script&lang=js&"
export * from "./energy-rating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports